module.exports = __webpack_public_path__ + "img/hipercard.2adc4dad.svg";